import React from 'react';
import { IRoleIds, IUser } from '../../pages/loginPage/loginInterface';
import { roleChecker } from '../../_helpers/checkerFunctions';
import RefreshLoader from '../refreshLoader/refreshLoader';

const FacilityRoleWrap: React.FC<{
  children: JSX.Element;
  loggedInUser: IUser;
  roleIds: IRoleIds;
}> = ({ children, loggedInUser, roleIds }) => {
  return roleChecker(
    loggedInUser?.roleId,
    roleIds.facilityAdminRoleId,
    roleIds.facilityUserRoleId
  ) ? (
    children
  ) : (
    <RefreshLoader />
  );
};

export default FacilityRoleWrap;
